import React from "react";
import classes from "../homepage/RoadMap.module.css";
import uranus from "../../assets/uranus.svg";
import saturns from "../../assets/saturn.svg";
import greenPlant from "../../assets/green_planet.svg";
import jupiter from "../../assets/jupiter.svg";
import { CheckRounded } from "@material-ui/icons";
import CircularProgress from "@mui/material/CircularProgress";

const RoadMap: React.FC = () => {
  return (
    <div className={classes["roadmap-wrapper"]}>
      <div className={classes["roadmap-content-wrapper"]}>
        <div className={classes["roadmap"]}>
          <div className={classes["roadmap-title"]} data-aos="fade-up">
            Kitties Roadmap
            <br /> Season 2!
          </div>
          <div className={classes["roadmap-desp"]} data-aos="fade-up">
            The Space Kitties have been spotted looking for more treasure, for
            them it’s never enough. They’ve scattered around the galaxy and now
            are looking for even more loot. However, the competition has gotten
            fierce. Be on the lookout for the S2 mech drop and let your Space
            Kittie become the ultimate pilot.
          </div>
          {/* Kitties Odyssey */}

          <section
            id={classes["cd-timeline"]}
            className={classes["cd-container"]}
            data-aos="fade-up"
          >
            <div className={classes["cd-timeline-block"]}>
              <div
                className={`${classes["cd-timeline-img"]} ${classes["cd-movie"]}`}
              >
                <img className={classes["roadmap-moon"]} src={saturns} alt="" />
              </div>
              <div
                className={classes["cd-timeline-content"]}
                data-aos="fade-right"
                style={{ background: "teal" }}
              >
                <div className={classes["rm-top"]}>
                  <div className={classes["rm-text"]}>
                    <h2>
                      {" "}
                      <CheckRounded id={classes["checked-icon"]} />
                      Complete
                    </h2>
                  </div>
                </div>
                <p>
                  3376 Genesis Space Kitties launched on the Solana blockchain.
                </p>
              </div>
            </div>

            <div className={classes["cd-timeline-block"]}>
              <div
                className={`${classes["cd-timeline-img"]} ${classes["cd-movie"]}`}
              >
                <img
                  className={classes["roadmap-moon"]}
                  src={greenPlant}
                  alt=""
                />
              </div>
              <div
                className={classes["cd-timeline-content"]}
                data-aos="fade-left"
                style={{ background: "teal" }}
              >
                <div className={classes["rm-top"]}>
                  <div className={classes["rm-text"]}>
                    <h2>
                      <CheckRounded id={classes["checked-icon"]} />
                      Complete
                    </h2>
                  </div>
                </div>
                <p>$PACE token drop to all Space Kitties holders.</p>
              </div>
            </div>

            <div className={classes["cd-timeline-block"]}>
              <div
                className={`${classes["cd-timeline-img"]} ${classes["cd-movie"]}`}
              >
                <img className={classes["roadmap-moon"]} src={jupiter} alt="" />
              </div>
              <div
                className={classes["cd-timeline-content"]}
                data-aos="fade-right"
              >
                <div className={classes["rm-top"]}>
                  <div className={classes["rm-text"]}>
                    <h2>In&nbsp;Progress</h2>
                  </div>
                </div>
                <p>
                  Gen2 Mech Public Launch. Which Mech will be the strongest?
                </p>
              </div>
            </div>
            <div className={classes["cd-timeline-block"]}>
              <div
                className={`${classes["cd-timeline-img"]} ${classes["cd-movie"]}`}
              >
                <img className={classes["roadmap-moon"]} src={uranus} alt="" />
              </div>
              <div
                className={classes["cd-timeline-content"]}
                data-aos="fade-left"
              >
                <div className={classes["rm-top"]}>
                  <div className={classes["rm-text"]}>
                    <h2>In&nbsp;Progress</h2>
                  </div>
                </div>
                <p>
                  Launch of the PvP Tournament game in the Battle Mech Arena.
                  Get your Mech and Space Kittie Pilot ready for action!
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      <img
        className={classes["planet-blue"]}
        src="../assets/planet_blue.png"
        alt=""
      />

      {/* <img className="cloud" src="../assets/Cloud_1.png" alt="" /> */}
    </div>
  );
};

export default RoadMap;
